<!--
  @template spin-kit-wave.component.html
  @description
  Template for SpinKitWaveComponent.
  Renders 5 animated rectangular bars using dynamic class binding based on SpinKit type.
  The layout uses the `children` array from the component class and applies class
  names dynamically via `buildClassStyleSkPart`.

  @accessibility
  Includes a visually hidden span for screen readers, announcing loading state.

  @structure
  <div class="sk-wave-rect"></div> (repeated 5x)
  <span class="visually-hidden">Loading...</span>
-->
@for (sk of children; track sk) {
  <div [ngClass]="buildClassStyleSkPart"></div>
}

<!--
  Screen-reader-friendly label to describe the purpose of the spinner.
-->
<span class="visually-hidden">Loading...</span>
